<template>
  <div class="page">

    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-header">
              <img :src="item.image" alt="Content Image" class="image" />
            </div>
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_4)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_5)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_4)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_6)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_5)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_7)" class="description"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/PlanandCases/CultureTour/VRParkCasesPage/CultureTour_VRPark.jpg"),
            title: "VR Park 宁波方特场馆",
            description_no_1:`
            <strong class="bold-text">0.引言</strong>
            `,
            description_1:`
              VR Park宁波方特场馆是匈牙利VR Vidámpark在中国的首个家庭娱乐度假场所，也是宁波方特首次与国际团队合作打造的高科技主题场馆。该场馆包括各种适合不同年龄层次的游戏、娱乐项目和设施，旨在提供一个让家庭成员可以一起放松、享受和增进感情的环境。

              VR Vidámpark正站在重新定义数字时代家庭娱乐的最前沿，以创新为根基，以创造难忘体验的激情为动力，打造和运营尖端的 VR/AR 家庭乐园。他们凭借在VR领域的先进技术和丰富的实践经验在欧洲取得了显著的成功，建立了中欧最大的VR主题乐园之一。VR Vidámpark在中国看到了巨大的市场潜力，希望通过VR Park宁波方特场馆探索中国市场，验证他们的创新解决方案，扩大其国际影响力。

              然而，在开拓中国市场的过程中，VR Vidámpark遇到了文化差异、政策法规差异以及语言和沟通等问题。在此背景下，我司与VR Vidámpark建立了合作关系，提供了一系列本地化支持和解决方案，以确保其在中国市场的顺利运营和发展。以下为我们在该案例中提供的主要服务内容：

            `,
            description_no_2:`<strong class="bold-text">1. 多方合作协调</strong>`,
            description_4:`a. 协助VR Park与物业方的合作，解决在项目推进过程中遇到的问题，例如关于场地设计的分歧。
            b. 解决跨文化思维方式差异问题，消除VR Vidámpark团队与中方合作团队在交流中产生的误解，并辅助对接双方的合作事宜。

            `,
            description_no_3: `<strong class="bold-text">2. 项目管理与运营</strong>`,
            description_5:`1. 协助选择合适的装修公司，并监督和管理施工过程，确保项目按时按质完成。
              2. 提供全面的项目管理服务，包括预算控制、进度管理和质量保证。
              3. 协助VR Park选择并管理营销代理机构，制定和执行开幕活动的营销计划。

            `,
            description_no_4: `<strong class="bold-text">3. 法律与财务本土化支持</strong>`,
            description_6: `1. 向VR Vidámpark团队解释中国的法律法规与文化习惯
              2. 提供财务管理支持，确保项目资金的合理使用和有效控制。

            `,
            description_no_5: ` <strong class="bold-text">案例成果</strong>`,
            description_7: `在我们与VR Vidámpark的携手共进下，VR Park宁波方特场馆于2024年10月正式开放。VR Park宁波方特场馆不仅是中外文旅合作的典例，也是高科技娱乐产业在中国市场的重要创新尝试。通过融合先进的VR/AR技术和丰富的文化元素，该场馆将为游客提供前所未有的沉浸式娱乐体验。我们期待这个项目能够促进中外文化交流，提升旅游体验的质量和水平，为当地文旅注入新的活力。我司将继续与VR Vidámpark携手，共同推动VR技术在中国文化旅游产业的发展，为更多游客带来独特的沉浸式体验。

            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image: require("@/assets/img/PlanandCases/CultureTour/VRParkCasesPage/CultureTour_VRPark.jpg"),
            title: "VR Park Ningbo Fangte Venue",
            description_no_1:`
            <strong class="bold-text">0.Intro</strong>
            `,
            description_1:`
              VR Park Ningbo Fangte venue is the first family entertainment holiday venue of Hungary's VR Vidámpark in China, and is also the first high-tech themed venue created by Ningbo Fangte in co-operation with an international team. The venue includes a variety of games, entertainment programmes and facilities for all ages, aiming to provide an environment where family members can relax, enjoy and bond together.

              VR Vidámpark is at the forefront of redefining family entertainment in the digital age, building and operating cutting-edge VR/AR family parks rooted in innovation and fuelled by a passion for creating unforgettable experiences. They have achieved remarkable success in Europe with their advanced technology and extensive hands-on experience in VR, establishing one of the largest VR theme parks in Central Europe.VR Vidámpark sees great market potential in China and hopes to explore the Chinese market through the VR Park Ningbo Fantasia venue, validating their innovative solutions and expanding their international reach.

              However, in the exploration of the Chinese market, VR Vidámpark encountered difficulties with cultural differences, differences in policies and regulations, as well as language and communication issues. Against this backdrop, we established a partnership with VR Vidámpark to provide a series of localisation support and solutions to ensure its smooth operation and development in the Chinese market. 
              
              Below are the main services we provided in this case:

            `,
            description_no_2:`<strong class="bold-text">1. Multi-party cooperation and coordination</strong>`,
            description_4:`a. Assist VR Park in its co-operation with the property owner and solve problems encountered in the course of the project, e.g. disagreements about the site design.
              b. Solve cross-cultural mindset differences, eliminate misunderstandings between the VR Vidámpark team and the Chinese co-operation team, and assist in matching the co-operation between the two parties.

              `,
            description_no_3: `<strong class="bold-text">2. Project Management and Operations</strong>`,
            description_5:`1. To assist in the selection of suitable renovation companies and to supervise and manage the construction process to ensure that the project is completed on time and with quality.
              2. Provide comprehensive project management services including budget control, schedule management and quality assurance.
              3. To assist VR Park in selecting and managing the marketing agency and to develop and execute the marketing plan for the opening event.

            `,
            description_no_4: `<strong class="bold-text">3. Legal & Financial Localisation Support</strong>`,
            description_6: `1. Explain Chinese laws, regulations and cultural practices to the VR Vidámpark team
              2. Provide financial management support to ensure the proper use and effective control of project funds.
              
            `,
            description_no_5: `<strong class="bold-text">Achievements</strong>`,
            description_7: `
            With our partnership with VR Vidámpark, the VR Park Ningbo Fantasia venue officially opens in October 2024.VR Park Ningbo Fantasia is not only an example of Sino-foreign cultural and tourism co-operation, but also an important and innovative attempt in the high-tech entertainment industry in the Chinese market. By integrating advanced VR/AR technology and rich cultural elements, the venue will provide visitors with an unprecedented immersive entertainment experience.

            We expect this project to facilitate cultural exchanges between China and the rest of the world, enhance the quality and level of the tourism experience, and inject new vitality into the local cultural tourism. We will continue to work hand in hand with VR Vidámpark to promote the development of VR technology in China's cultural tourism industry and bring unique immersive experiences to more visitors.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
